define(function(require) {
    const tpl = require('./t_itv_warn_existing_account.hbs');
    const ViewManager = require('civicsUtils/view_manager');
    const LoginModel = require('civicsModels/login_model');
    const SocialIdentityModel = require('civicsModels/social_identity_model');
	const Handlebars = require('handlebars');
	const LoginStatusModel = require('civicsModels/login_status_model');
	const factor_utility = require('civicsViews/core/two_factor_authentication/2fa_utility');
	const ccn = require('civicsViews/core/core_constants');
	const confirmationModal = require('civicsViews/confirmation_modal/v_lov_confirmation_modal');

    return Marionette.LayoutView.extend({
        template:tpl,
        ui: {
            newAccountButton: '.new-account-button',
            linkExistingAccountButton: '.link-existing-account-button',
            linkButton: '.link-button',
            closeButton:'.bbm-btn-close',
            username: '.link-username input', 
            password: '.link-password input',
            returnToLoginButton: '.return-to-login-button',
            modalTitle: '#modal-title-existing-account',
            existingAccountWarning: '.existing-account-warning',
            existingAccount: '.existing-account'
        },
        events: {
            'click @ui.newAccountButton' : 'redirectToRegister',
            'click @ui.linkExistingAccountButton' : 'linkExistingAccountButtonClicked',
            'click @ui.closeButton':'cancelClicked',
            'click @ui.linkButton':'linkClicked',
            'click @ui.returnToLoginButton': 'returnToLogin'
        },
        initialize: function(options) {
            this.config = options.config;
            this.provider = options.provider;
            this.socialInfo = options.socialInfo;
            this.linkCallback = options.linkCallback;
            this.redirectCallback = options.redirectCallback;
            this.showNewAccountButton = options.showNewAccountButton;
        },
        onRender: function () {
            this.$el.rhythmThemeInitCivics();
            this.$el.rhythmThemeInit();
            this.ui.linkButton.addClass("hidden");
            ViewManager.loading(false, null, true);
        },
        cancelClicked: function (e) {
             if(e) {
                e.preventDefault();
                e.stopPropagation();
            }

            this.destroy();
            window.location.assign(this.config.loginPage);
        },
        linkExistingAccountButtonClicked: function (e) {
             if(e) {
                e.preventDefault();
                e.stopPropagation();
            }

            this.ui.linkButton.removeClass("hidden");
            this.ui.newAccountButton.addClass("hidden");
            this.ui.linkExistingAccountButton.addClass("hidden");
            this.ui.existingAccountWarning.html(i18n.t('CIVICS.LOGIN.LINK_WARNING'));
            this.ui.existingAccount.removeClass("hidden");
            this.ui.modalTitle.text(i18n.t('CIVICS.LOGIN.LINK_EXISTING_ACCOUNT'));
        },
        redirectToRegister: function () {
            if(this.redirectCallback){
                this.redirectCallback();
            }
        },
        returnToLogin: function() {
            window.location.assign(this.config.loginPage);
        },
        linkClicked: function (e) {
            if(e) {
                e.preventDefault();
                e.stopPropagation();
            }

            ViewManager.loading(true);
            var error = {};
            var validationError = {};
            var username = this.ui.username.val();
            var password = this.ui.password.val();

            if(username.length == 0){
                validationError.username = i18n.t('CIVICS.LOGIN.USERNAME_REQUIRED');
            }

            if(password.length == 0){
                validationError.password = i18n.t('CIVICS.LOGIN.PASSWORD_REQUIRED');
            }
            error.validationError = validationError;

            if(Object.keys(validationError).length > 0){
                ViewManager.errorToWindow(error, this);
            } else {
                this.model = new LoginModel();
                this.model.set('username', username);
                this.model.set('password', password);
                this.model.save().done( (model, response) => {
                    ViewManager.loading(false);
                    this.linkSocialIdentity();
                   
                
                 }).fail((response, status, xhrResponse)=> {
                    if (response.statusCode().status == 401 && 
                        response.responseJSON?.data?.mfaStatus &&
                        response.responseJSON.data.mfaStatus.toLowerCase() == ccn.NOTIFIED) {
                        ViewManager.loading(false);
                        this.showMFAWarning(response);
                    } else {
                        ViewManager.loading(false);
                        if( response.statusCode().status == 423 ){
                            ViewManager.openAlert( i18n.t('CIVICS.COMMON.SERVER_ERRORS.MAINT_MODE'), true);
                        }
                        else {
                            ViewManager.openAlert(i18n.t('CIVICS.LOGIN.SIGN_IN_ERROR'));
                        }
                    }
                 });

            }

           
            
        },

        linkSocialIdentity: function() {
            ViewManager.loading(true);


            var socialIdentityModel = new SocialIdentityModel();
     
            socialIdentityModel.set('email', this.socialInfo?.email);
            socialIdentityModel.set('provider', this.provider.providerId);
            socialIdentityModel.set('registrationToken', this.socialInfo?.registrationToken);
            socialIdentityModel.set('providerDisplayName', this.socialInfo?.providerDisplayName);
            socialIdentityModel.set('providerUserId', this.socialInfo?.uniqueIdentifier);
            socialIdentityModel.save().done( (model, response) => { 
                ViewManager.loading(false);
                if(this.linkCallback){
                    this.linkCallback(model,response);
                } 
                

            })
            .fail((response, status, xhrResponse)=> {
                ViewManager.loading(false);
                console.error('Social identity linking failed:', response);
                ViewManager.openAlert(i18n.t('CIVICS.LOGIN.OAUTH_LOGIN_FAILED'));
            });
        },
        createFactorUtility: function() {
            return new factor_utility({
                modalRegion: this.options?.modalRegion
            });
        },
        handleFactorAuthentication: function(response) {
            let faUtil = this.createFactorUtility();
            faUtil.authenticate(response, this.model).done(() => {
                this.linkSocialIdentity();
            }).fail(() => {
                ViewManager.openAlert(i18n.t('CIVICS.LOGIN.SIGN_IN_ERROR'));
            });
        },
        showMFAWarning: function(response) {
            let confirmationView = new confirmationModal({
                title: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.AUTHENTICATION_MODAL_TITLE'),
                instructions: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.DISABLE_MFA_TEXT_SOCIAL_LOGIN', {providerName: this.provider.providerName}),
                submitButtonText: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.DISABLE_MODAL_SUBMIT_BUTTON'),
                cancelButtonText: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.DISABLE_MODAL_CANCEL_BUTTON'),
                confirmationCallback: () => {
                    this.handleFactorAuthentication(response);
                },
                cancellationCallback: () => {
                    // User cancelled, do nothing
                }
            });
            
            let faUtil = this.createFactorUtility();
            faUtil.showModalView(confirmationView);
        },
        templateHelpers: function() {
            return {
                config: this.config,
                showNewAccountButton: this.showNewAccountButton,
                EmailUsernameLabel: ((this.config.EmailUsernameOn) ? i18n.t('CIVICS.LOGIN.EMAIL_ADDRESS') : i18n.t('CIVICS.LOGIN.USERNAME')),
				EmailUsernameAutocomplete: (this.config.EmailUsernameOn) ? "email" : "username",
                existingAccountWarning: Handlebars.helpers['global:html']( i18n.t('CIVICS.LOGIN.EXISTING_ACCOUNT_WARNING')),
                modalTitle: i18n.t('CIVICS.LOGIN.FOUND_EXISTING_ACCOUNT') 

            };
        }
    });
});